import React from 'react';
import Icon from './Icon';

export default class ChevronLeft extends Icon {
  icon = (
    <svg viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        transform="rotate(90 892 828)"
        d="M1683 808l-742 741q-19 19-45 19t-45-19l-742-741q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z"
      />
    </svg>
  );
}
